import { Badge } from '@cimplico/components';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import { SubscriptionTier } from '../../../../types/firm';
import FirmInsights from '../../../firm-insights/FirmInsights';
import EntityOverviewInsightsFilter from './EntityInsightsFilter';
import UpgradePrompt from '../../../../components/upgrade-prompt/UpgradePrompt';
import { useHasFeatureAccess } from '../../../../hooks/use-has-feature-access';

function EntityInsights(): JSX.Element {
    const featureAccess = { canViewEntityInsightsFilter: useHasFeatureAccess('entity-insights-filter:read') };

    const [filter, setFilter] = useState('');
    const [promptUpgrade, setPromptUpgrade] = useState(false);

    return (
        <div className="grid gap-y-8">
            {promptUpgrade && <UpgradePrompt onClose={(): void => setPromptUpgrade(false)} targetTier={SubscriptionTier.PROFESSIONAL} />}
            {!featureAccess.canViewEntityInsightsFilter && (
                <button
                    className="relative w-fit inline-flex justify-center items-center border border-gray-300 dark:border-white/[0.12] text-gray-700 dark:text-white/[0.87] bg-white dark:bg-white/[0.12] shadow-sm px-3 py-1.5 rounded-md"
                    onClick={(): void => setPromptUpgrade(true)}
                >
                    <label className="font-medium text-sm leading-4 mr-1">Filter</label>
                    <Badge shape="rounded" color="gray" size="small" label={'0'} />
                    <ChevronDownIcon className="h-5 w-5 ml-2 -mr-1" />
                </button>
            )}
            {featureAccess.canViewEntityInsightsFilter && <EntityOverviewInsightsFilter onFilterChange={setFilter} />}
            <FirmInsights filter={filter} subscriptionTierRequired />
        </div>
    );
}

export default EntityInsights;
